export const PRODUCT_OBJ = {
    us: [
        [
            // 第一个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '15350808346697',
                variantId: '54553979682889',
                amazonUrl: 'https://www.amazon.com/dp/B0FDQHJWXS?maas=maas_adg_A0C5D9014CB2CCFAFF4EC2EB61B592F1_afap_abs&ref_=aa_maas&tag=maas',
            },
        ],
        [
            // 第二个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '15350808346697',
                variantId: '54553980043337',
                amazonUrl: 'https://www.amazon.com/dp/B0FDQGHXP8?maas=maas_adg_E481E095246D58DF269A2D4F496B4F93_afap_abs&ref_=aa_maas&tag=maas',
            },
        ],
        [
            // 第三个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '15350808346697',
                variantId: '54590654840905',
            },
        ],
        [
            // 第四个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '15350808346697',
                variantId: '54590654808137',
            },
        ],
        [
            // 第五个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '15350808346697',
                variantId: '54553980141641',
                isOnSale: false,
            },
        ],
        [
            // 第六个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '15350808346697',
                variantId: '54590654906441',
                isOnSale: false,
            },
        ],
    ],
    ca: [
        [
            // 第一个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '15127284351347',
                variantId: '52734893490547',
                amazonUrl: 'https://www.amazon.ca/dp/B0FDQHJWXS?maas=maas_adg_6FF4FCFA54573E64A4135BE3A6676130_afap_abs&ref_=aa_maas&tag=maas',
            },
        ],
        [
            // 第二个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '15127284351347',
                variantId: '52734893523315',
                amazonUrl: 'https://www.amazon.ca/dp/B0FDQGHXP8?maas=maas_adg_0A9E4B095EE0FF426DD5EF34115B8A3B_afap_abs&ref_=aa_maas&tag=maas',
            },
        ],
        [
            // 第三个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '15127284351347',
                variantId: '52734893588851',
            },
        ],
        [
            // 第四个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '15127284351347',
                variantId: '52739674538355',
            },
        ],
        [
            // 第五个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '15127284351347',
                variantId: '52739674603891',
            },
        ],
        [
            // 第六个产品组 超早鸟 => 早鸟 => 常规
            {
                productId: '15127284351347',
                variantId: '52734893556083',
                isOnSale: false,
            },
        ],
    ],
};
